import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '../lib/auth-store';
import { ROLE_LANDING_PATH } from '../components/nav';

/**
 * Legacy entry path. The portal's old generic dashboard has been replaced
 * by role-specific landing pages (Phase 1 of the queue-first IA pivot). We
 * keep this route alive so anything that still navigates to `/dashboard`
 * (e.g. the post-login redirect, a saved bookmark) lands on the right place.
 *
 * Role → landing mapping lives in `components/nav.ts` — do not redefine.
 */
export const Route = createFileRoute('/_authed/dashboard')({
  beforeLoad: () => {
    const user = useAuthStore.getState().user;
    if (!user) return;
    const target = ROLE_LANDING_PATH[user.primaryRole];
    if (!target) return;
    throw redirect({ to: target, replace: true });
  },
  // beforeLoad always throws when a user is loaded; this fallback only fires
  // if redirection somehow doesn't happen (auth race) — render nothing.
  component: () => null,
});
